import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Aboutcard from "./AboutCard";
/*import laptopImg from "../../Assets/about.png";*/
import laptopImg from "../../Assets/iVertex_black.png";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      
      <Container>
      <img src={laptopImg} alt="about" className="img-fluid" width={250}/>
      <p></p>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h2 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              What iVertex can do for  <br></br> <strong className="purple">Your Organization</strong>
            </h2>
            <Aboutcard />
          </Col>

        </Row>

      </Container>
    </Container>
  );
}

export default About;
